export const DEFAULT_SLIPPAGE_TOLERANCE_PERCENTAGE = 0.5;
export const MAXIMUM_SLIPPAGE_TOLERANCE_PERCENTAGE = 20;
export const HIGH_PRICE_IMPACT_THRESHOLD_PERCENTAGE = 3;
export const MAXIMUM_PRICE_IMPACT_THRESHOLD_PERCENTAGE = 10;
export const HIGH_SLIPPAGE_PERCENTAGE = 5;
